var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx, Fragment as _Fragment, jsxs as _jsxs } from "react/jsx-runtime";
import { Option, Select } from "@mui/joy";
import FieldEditor from "./fieldEditor";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faMinusCircle, faPlusOctagon } from "@fortawesome/pro-solid-svg-icons";
import { useEffect, useState } from "react";
import copy from "fast-copy";
import { useTranslation } from "react-i18next";
export default function GroupEditor(_a) {
    var _b;
    var filter = _a.filter, depth = _a.depth, onFilterUpdated = _a.onFilterUpdated, module = _a.module;
    var operators = { and: "AND", or: "OR" };
    var rulesCount = ((_b = filter.rules) === null || _b === void 0 ? void 0 : _b.length) || 0;
    var t = useTranslation(["common"]).t;
    var addFilter = function (filter$) {
        var _a;
        var filters = copy(filter);
        (_a = filters.rules) === null || _a === void 0 ? void 0 : _a.push(filter$);
        onFilterUpdated(filters); // T
    };
    var updateFilter = function (filter$, newFilter) {
        var index = filter.rules.findIndex(function (e) { return e === filter$; });
        var filters = copy(filter);
        filters.rules.splice(index, 1, copy(newFilter));
        onFilterUpdated(filters);
    };
    var addField = function () {
        var newfield = {
            operator: "",
            field: "",
            value: "",
        };
        addFilter(newfield);
    };
    var addGroup = function () {
        var newGroup = {
            operator: "",
            rules: [],
        };
        addFilter(newGroup);
    };
    var removeFilter = function (item) {
        var index = filter.rules.findIndex(function (e) { return e === item; });
        var filters = copy(filter);
        filters.rules.splice(index, 1);
        onFilterUpdated(filters);
    };
    var _c = useState("and"), operatorGlobale = _c[0], setOperatorGlobale = _c[1];
    useEffect(function () {
        onFilterUpdated &&
            onFilterUpdated(__assign(__assign({}, filter), { operator: "and" }));
    }, []);
    return (_jsxs("div", __assign({ className: "flex flex-col w-full" }, { children: [_jsxs("div", __assign({ className: "flex flex-row items-center p-2 ".concat(rulesCount > 1 ? " pl-4" : "") }, { children: [filter.rules.length > 1 && (_jsx(_Fragment, { children: _jsx(Select, __assign({ className: "w-20 mb-2", size: "sm", 
                            // defaultValue="and"
                            value: operatorGlobale, onChange: function (event, value) {
                                setOperatorGlobale(value);
                                onFilterUpdated(__assign(__assign({}, filter), { operator: value }));
                            } }, { children: Object.keys(operators).map(function (operator) { return (_jsx(Option, __assign({ value: operator }, { children: operators[operator] }), operator)); }) })) })), _jsx("ul", __assign({ className: "w-full ".concat(rulesCount > 1 ? " border-l-slate-200 pl-4 border-l-2 ml-12" : "") }, { children: filter.rules.map(function (f, index) { return (_jsxs("li", __assign({ className: "list-none" }, { children: ["rules" in f && (_jsxs("div", __assign({ className: "flex flex-row items-stretch" }, { children: [_jsx(GroupEditor, { filter: f, depth: (depth || 0) + 1, onFilterUpdated: function (value) {
                                                updateFilter(f, value);
                                            }, module: module }, index), _jsx("div", __assign({ className: "space-x-1 px-4 flex flex-row items-center justify-center pt-2 bg-gray-100 text-[rgb(var(--color-blue-300))]" }, { children: _jsx(FontAwesomeIcon, { icon: faMinusCircle, className: "cursor-pointer", onClick: function () { return removeFilter(f); } }) }))] }))), !("rules" in f) && (_jsxs("div", __assign({ className: "flex flex-row items-center" }, { children: [_jsx(FieldEditor, { filter: f, onFilterUpdated: function (value) {
                                                updateFilter(f, value);
                                            }, module: module }, index), _jsx("div", __assign({ className: "space-x-1 pl-4 text-[rgb(var(--color-slate-400))]" }, { children: _jsx(FontAwesomeIcon, { icon: faMinusCircle, className: "cursor-pointer", onClick: function () { return removeFilter(f); } }) }))] })))] }), index)); }) }))] })), _jsxs("div", __assign({ className: "flex flex-row justify-end space-x-1 py-2 items-center border-t-slate-200 border-t-2" }, { children: [_jsxs("button", __assign({ className: "button primary text-sm", onClick: addField }, { children: [_jsx(FontAwesomeIcon, { icon: faPlusOctagon }), "\u00A0", t("app.LBL_FILTER_FIELD")] })), _jsxs("button", __assign({ className: "button primary text-sm", onClick: addGroup }, { children: [_jsx(FontAwesomeIcon, { icon: faPlusOctagon }), "\u00A0 ", t("app.LBL_FILTER_GROUP")] }))] }))] })));
}
